<template>
	<div class="flex-fill d-flex overflow-hidden">
		<div v-if="showLoader" class="loader1">
			<div>
				<div class="lds-ripple">
				<div></div>
				<div></div>
				</div>
			</div>
		</div>
		<transition name="collapse-width">
			<!-- <div v-show="showList" :class="{ 'd-flex flex-column': showList }" > -->
			<div class="forIpadUIConvo d-flex flex-column">
				<div id="ConvoList" class="bg-white border flex-fill d-flex flex-column overflow-hidden">
					<div class="d-flex p-3 border-bottom">
						<div class="flex-fill position-relative">
							<b-input type="search" placeholder="Search Conversations..." v-model="search" debounce="500"/>
							<b-list-group class="text-center position-absolute w-100">
								<b-list-group-item
									class="py-2"
									:key="prosp.id"
									style="z-index: 1000"
									v-for="prosp in filteredProspects"
									button @click="openSearch(prosp)"
								>
									{{$parseAlias(prosp)}}
								</b-list-group-item>
							</b-list-group>
						</div>
						<b-dropdown variant="outline" right toggle-class="mr-1" >
							<template v-slot:button-content>
								<b class="filterHead">Filter</b>
							</template>
							<b-dropdown-group style="max-height: 22em; overflow-y: auto">
								<h6 class="text-center text-blue">Defaults</h6>
								<!-- Recent Filter -->
								<b-dropdown-item-button v-if="sort != 0" @click="filterClick(0)">Recent</b-dropdown-item-button>

								<!-- Oldest Filter -->
								<b-dropdown-item-button v-if="sort != 1" @click="filterClick(1)">Oldest</b-dropdown-item-button>

								<!-- Unread Filter -->
								<b-dropdown-item-button v-if="sort != 2" @click="filterClick(2)">
								Unread 
								<!-- <span v-if="scope1 && !scope1Loader">({{ unreadCountTotal }})</span>
								<span v-if="scope1Loader" class="loader4"></span> -->
								</b-dropdown-item-button>

								<!-- Due Task Filter -->
								<b-dropdown-item-button v-if="sort != 3" @click="filterClick(3)">
								Due Task 
								<!-- <span v-if="scope2 && !scope2Loader">({{ dueTaskCountTotal }})</span>
								<span v-if="scope2Loader" class="loader4"></span> -->
								</b-dropdown-item-button>

								<!-- Starred Filter -->
								<b-dropdown-item-button v-if="sort != 4" @click="sortByStarred()">
								Starred 
								<!-- <span v-if="scope3 && !scope3Loader">({{ startCount }})</span>
								<span v-if="scope3Loader" class="loader4"></span> -->
								</b-dropdown-item-button>

								<!-- Scheduled Filter -->
								<b-dropdown-item-button v-if="sort != 5" @click="filterClick(5)">
								Scheduled 
								<!-- <span v-if="scope4 && !scope4Loader">({{ scheduleCountTotal }})</span>
								<span v-if="scope4Loader" class="loader4"></span> -->
								</b-dropdown-item-button>

								<!-- Autopilot Active Filter -->
								<b-dropdown-item-button v-if="sort != 6" @click="filterClick(6)">
								Autopilot Active 
								<!-- <span v-if="scope5 && !scope5Loader">({{ autopilotCountTotal }})</span>
								<span v-if="scope5Loader" class="loader4"></span> -->
								</b-dropdown-item-button>
								<b-dropdown-item-button v-if="sort != 7" @click="filterClick(7)">
									Feedback Needed 
								</b-dropdown-item-button>
								<b-dropdown-item-button v-if="sort != 8" @click="filterClick(8)">
									Errored 
								</b-dropdown-item-button>
								<hr>
								<!-- @click="sort = 5 + i" -->
								<div v-if="user.Folders">
									<h6 class="text-center text-blue">Folders</h6>
									<b-dropdown-item-button
										:key="i"
										@click="sortByFolder(i)"
										v-for="i in user.Folders.length"
									>
										<span v-if="sort != 5 + i">{{user.Folders[i - 1]}}</span>
									</b-dropdown-item-button>
									<hr>
								</div>
								<div v-if="user.Stages">
									<h6 class="text-center text-blue">Stages</h6>
									<b-dropdown-item-button
										:key="i + user.Folders.length"
										@click="sortByStage(i);"
										v-for="i in user.Stages.length"
									>
										<span v-if="sort != 5 + user.Folders.length + i">{{user.Stages[i - 1]}}</span>
									</b-dropdown-item-button>
									<b-dropdown-item-button @click="sort = -1" v-if="sort != -1">
										Archived
									</b-dropdown-item-button>
								</div>
								<hr>
								<div>
									<h6 class="text-center text-blue">Assessment</h6>
									<!-- <b-dropdown-item-button>Priority:0 </b-dropdown-item-button> -->
									<!-- <b-dropdown-item-button @click="sortByPriority(0)">Priority:0 </b-dropdown-item-button> -->
									<b-dropdown-item-button @click="sortByPriority(1)">Priority:1 </b-dropdown-item-button>
									<b-dropdown-item-button @click="sortByPriority(2)">Priority:2 </b-dropdown-item-button>
									<b-dropdown-item-button @click="sortByPriority(3)">Priority:3 </b-dropdown-item-button>
								</div>
							</b-dropdown-group>
						</b-dropdown>
					</div>
					<div v-if="sort == 0 || sort == 1 || sort == 2 || sort == 3 || sort == 5 || sort == 6 || sort == 7 || sort == 8" ref="convoList" class="flex-fill overflow-auto position-relative yscrollbar LoadMoreConvoScroll" id="yscrollbarstyle-1">
						<!-- <h1>{{sortedConvos}}</h1> -->
						<ConversationItem
							:active="activeConvo == convo.id"
							:key="convo.id"
							v-for="convo in sortedConvos"
							:filter="sort"
							:convo="convo"
							@open="openConvo"
						/>
						<h5 v-if="!sortedConvos.length" class="center text-black-50">No Conversations</h5>
					</div>
					<div v-if="sort == 4 || sort > 8" ref="convoList" v-on:scroll="OnScroll" class="flex-fill overflow-auto position-relative LoadMoreConvoScroll">
						<ConversationItem
							:active="activeConvo == convo.id"
							:key="convo.id || index"
							v-for="convo in filteredConvos"
							:filter="sort"
							:convo="convo"
							@open="openConvo"
							:isPriorityClicked="isPriorityClicked"
						/>
						<h5 v-if="!filteredConvos.length" class="center text-black-50">No Conversations</h5>
					</div>
				</div>
			</div>
		</transition>
		<MessageLog id="MessageLog" v-if="this.extensionuuid == null" :prospect="prosp" :convo="convo" @open="changePage" @showLoader="manageLoader"   @getCallDetails="getCallDetails"   @testAutoConvo="getAutoConvoData"/>
		<MessageLogcopy id="MessageLog" v-if="this.extensionuuid != null" :prospect="prosp" :convo="convo" @open="changePage" @showLoader="manageLoader"   @getCallDetails="getCallDetails"   @testAutoConvo="getAutoConvoData"/>
		
		<div v-if="convo || prosp" v-show="page == 'prosp'" transition="collapse-width">
			<div  :class="{ 'd-flex flex-column': page == 'prosp' }">
				<div id="Prospect" class="bg-white border flex-fill d-flex flex-column overflowY-auto">
					<Prospect
						:prospect="prosp"
						:number="prosp ? prosp.Number : convo.ClientNumber"
						@open="changePage"
						@delete="deleteProsp"
						@showLoader="manageLoader"
					/>
				</div>
			</div>
		</div>
		<b-modal id="ProspectModal1" hide-footer v-if="isNewProsp">
			<template v-slot:modal-title>
				Create Prospect
			</template> 
			<b-form @submit.stop.prevent="createProspect">
				<b-form-group label-cols="5" label="First Name:" class="my-1">
					<b-form-input
						type="text"
						v-model="form.First"
						required />
				</b-form-group>
				<b-form-group label-cols="5" label="Last Name:" class="my-1">
					<b-form-input
						type="text"
						v-model="form.Last"/>
				</b-form-group>
				<b-form-group label-cols="5" label="Email:" class="my-1">
					<b-form-input
						type="email"
						v-model="form.Email"/>
				</b-form-group>
				<b-form-group label-cols="5" label="Phone number:" class="my-1">
					<b-form-input
						type="tel" 
						placeholder="(xxx) xxx-xxxx"
						v-mask="'(###) ###-####'"
						v-model="form.Number"
						/>
				</b-form-group>
				<b-form-group label-cols="5" label="Postal Code:" class="my-1">
					<b-form-input
						type="text"
						@keydown="isCheckPostalCode($event)"
						v-model="form.Zip"/>
				</b-form-group>
				<b-form-group label-cols="5" label="Status:" class="my-1">
					<b-form-select
						:options="user.Stages"
						v-model="form.Status"/>
				</b-form-group>
				<b-form-group label-cols="5" label="Tags:" class="my-1">
					<b-form-checkbox-group v-model="form.Tags">
						<b-form-checkbox :value="user.Folders[i-1]" :key="i" v-for="i in user.Folders.length">
							{{user.Folders[i-1]}}
						</b-form-checkbox>
					</b-form-checkbox-group>
				</b-form-group>
				<b-form-group label-cols="5" label="Notes:" class="my-1">
					<b-form-input
						type="text"
						v-model="NoteValue"/>
				</b-form-group>
				<b-form-checkbox
					v-model="optIn"
					class="my-3"
					required>
						<small>This prospect has given me permission to contact them via text message</small>
				</b-form-checkbox>
				<b-button type="submit" block variant="outline-primary">Save Prospect</b-button>
			</b-form> 
		</b-modal> 
	</div>
</template>

<script>
	import ConversationItem from './subcomponents/ConversationItem'
	import MessageLogcopy from './subcomponents/MessageLogcopy'
	import MessageLog from './subcomponents/MessageLog'
	import Prospect from './subcomponents/Prospect'
	import { mapState } from 'vuex'
	import { db,getPhoneData } from 'src/db.js'

	export default {
		name: "Conversations",
		components: {
			ConversationItem,
			MessageLogcopy,
			MessageLog,
			Prospect
		},
		computed: {
			convo() {
				if (!this.activeConvo) {
					return null;
				}
				return this.convos.find(convo => convo.id == this.activeConvo);
			},
			prosp() {
				if (!this.activeProsp) {
					return null;
				}
				return this.prospects.find(prosp => prosp.id == this.activeProsp);
			},
			showList() {
				return this.page == 'list' ||
					(this.page == 'convo' && this.format == 'big');
			},
			filteredProspects() {
				if (!this.search) {
					return [];
				}
				let prospMatches = this.prospects.filter(prosp => {
					let ret = false;
					if (prosp.Number) {
						ret = prosp.Number.includes(this.search) ||
								this.$parseNumber(prosp.Number).includes(this.search);
					}
					return ret || this.$parseAlias(prosp).toLowerCase().includes(this.search.toLowerCase());
				});
				if (prospMatches.length == 0) {
					return [{First: 'No', Last: 'Matches'}];
				}
				return prospMatches.slice(0, 8);
			},
			sortedConvos() {
				let convos = this.convos;
				// case 1-2-default
				// .slice(0, 30 * this.convoListHeight)
				// let convos = this.convos.slice(0, 30 * this.convoListHeight);
				// if (this.emails.length) {
				// 	for (let convo of convos) {
				// 		let findp = this.prospects.find(p => p.Number == convo.ClientNumber);						
				// 		if (findp) {
				// 			convo.prospId = findp.id;
				// 			let finde = this.emails.find(e => e.ProspectID == convo.prospId);
				// 			if (finde) {
				// 				convo.isMailExist = true;
				// 				convo.emailConvoID = finde.id;
				// 				if (convo.Unread == 0) {
				// 					convo.Unread = finde.Unread;
				// 				}
				// 				if (convo.DateUpdated < finde.DateUpdated) {
				// 					convo.EmailDateUpdated = finde.DateUpdated;
				// 					// convo.DateUpdated = finde.DateUpdated;
				// 				}
				// 			}
				// 		}
				// 	}
				// }
				// this.makeLoaderTrue();
				switch (this.sort) {
					case 0:
						return this.sortByRecent();
					case 1:
						// return convos.sort((a, b) => a.DateUpdated - b.DateUpdated).slice(0, 30 * this.convoListHeight);
						return this.sortByOldest();
					case 2:
						return convos.filter(convo => convo.Unread).slice(0, 30 * this.convoListHeight);
						// return this.sortByUnread(convos)
					case 3:
						return this.sortByDueTask(convos).slice(0, 30 * this.convoListHeight);
					case 4:
						return this.sortByStarred()
					case 5:
						return this.sortByScheduled(convos)
					case 6:
						return this.sortByAutopilot(convos)
					case 7:
						return this.sortByFeedbackNeeded(convos)
					case 8:
						return this.soryByErrored(convos);
					default:
						return this.sortByFolder();
				}
				
			},
			...mapState('globals', ['scrollTop', 'activeConvo', 'activeProsp', 'format','startCount','unreadCountTotal','autopilotCountTotal','scheduleCountTotal','dueTaskCountTotal']),
			...mapState('firebase', ['prospects', 'convos', 'user','emails','calls','phones','extensionuuid','fcmToken','messages'])
			// ...mapState('firebase', ['prospects', 'convos', 'user'])
		},
		created(){
			if (performance.memory.usedJSHeapSize > 1000000000) { // 1 GB
				//eslint-disable-next-line
				console.log("memory heap size");
				// this.$store.dispatch('firebase/clearBoundData');
				// this.$store.dispatch('globals/CLEAR_ALL');
			}
			this.getEmailsFromDB();
			this.oldConvos = JSON.parse(JSON.stringify(this.convos));
			if(this.extensionuuid != null && this.extensionuuid != 0){
			//eslint-disable-next-line
			console.log("extensionuuid", this.extensionuuid);
			let findp = this.prospects.find(p => this.normalizePhoneNumber(p.Number) == this.extensionuuid);	
			if(findp){
			// let c = this.convos.find(convo => this.normalizePhoneNumber(convo.ClientNumber));
			// this.openConvo(c.id,findp.id);
			this.openSearch(findp);
			}else{
				this.isNewProsp=true;
				//eslint-disable-next-line
				console.log("Not find prospects");
				this.form.Number=this.extensionuuid;
				setTimeout(() => {	
					this.$bvModal.show('ProspectModal1');
				}, 500);
			}
			}
		},
		methods: {
			// ALLOW ONLY LETTERS, DIGITS AND WHITE SPACE
			isCheckPostalCode(e) {
				var value =  e.target.value;
				if (!e.key.match(/[a-zA-Z0-9 ]/) || (e.key == ' ' && value[value.length-1] == ' ')) {
					e.preventDefault();  
				}
			},
			async createProspect() {
				if (!this.optIn) {
					alert("Prospect cannot be added unless express permission is given");
					return;
				}
				if (this.NoteValue) {
					let notesArray = [{
						'date': Date.now(),
						'description': this.NoteValue,
						'mediaURL': ''
					}];
					this.form.Notes = notesArray;
				} else {
					this.form.Notes = [];
				}

				this.form.Stages = [{Date:new Date().valueOf(), Stage:this.form.Status}];
				
				this.$bvModal.hide('ProspectModal1');
				this.showLoader = true;
				
				// if (this.form.Number) {
				// 	await getPhoneData({Number:this.form.Number})
				// 	// .then((res) => {this.showPhoneData(res)})
				// 	// .catch(err => this.showPhoneError(err));
				// }
				let formattedNum = this.form.Number;
				this.form.Number = this.$parseNumber(this.form.Number);
				this.form.Source = 'Manual Entry';

				var endSpace = /\s+$/;
				if(this.form.First != '' && this.form.First !== 'undefined') {
                    if(endSpace.test(this.form.First)){
                        this.form.First = (this.form.First).replace(/\s+$/,''); 
                    }
                } 
				if(this.form.Last != '' && this.form.Last !== 'undefined') {
                    if(endSpace.test(this.form.Last)){
                        this.form.Last = (this.form.Last).replace(/\s+$/,''); 
                    }
                }
				if(this.form.Email != '' && this.form.Email !== 'undefined') {
                    if(endSpace.test(this.form.Email)){
                        this.form.Email = (this.form.Email).replace(/\s+$/,''); 
                    }
                }
				if(this.form.Zip != '' && this.form.Zip !== 'undefined') {
                    if(endSpace.test(this.form.Zip)){
                        this.form.Zip = (this.form.Zip).replace(/\s+$/,''); 
                    }
                }
				//eslint-disable-next-line
				console.log("form data",this.form);

				Promise.all([
					db.collection(`Users/${this.user.id}/Prospects`).add({
						...this.form,
						DateCreated: Date.now()
					}),
				])
				.then(values => {
					this.form = {};
					this.form.Status = "New";
					this.optIn = false;
					// this.$bvModal.hide('ProspectModal');
					let prosp = this.prospects.find(prosp => values[0].id == prosp.id);
					if (prosp) {
						setTimeout(() => {
							this.showLoader = false;
							this.emitProsp(prosp);
						}, 3000);
					}
					this.NoteValue = '';
				})
				.catch(err => {
					this.form.Number = formattedNum;
					this.$emit('error', err);
				})
			},
			normalizePhoneNumber(phoneNumber) {
			// Remove all non-digit characters from the phone number
			const normalizedNumber = phoneNumber.replace(/\D/g, "");
			if (normalizedNumber.startsWith('1')) {
				return normalizedNumber.substring(1);
			}
			return normalizedNumber;
			},
			emitProsp(prosp) {
				this.search = '';
				let findConvo;
				if(this.convos != null) {
					findConvo = this.convos.find(convo => convo.ClientNumber == prosp.Number);
				}
				this.$store.commit('globals/SET', { var: 'activeProsp', val: prosp.id });
				this.$store.commit('globals/SET', { var: 'activeConvo', val: findConvo.id });
				this.$store.dispatch('firebase/bindMessages', findConvo.id);
				if (this.emails && this.emails.length) {
					let mid = this.getEmailConvoID(prosp.id);
					if (mid) {
						this.$store.dispatch('firebase/bindMails', mid);
					}else {
						this.$store.dispatch('firebase/clearonlyMailsData');
					}
					// this.$store.dispatch('firebase/bindMails', this.getEmailConvoID(prosp.id));
				}
				// if (this.$route.path != '/chrome/Conversations') {
				// 	this.$router.push('/chrome/Conversations');
				// }
				this.$emit('open', 'prosp');
			},
			getAutoConvoData(data){
               this.autoConvoDetail = data;
			},
			async getEmailsFromDB(){
				if(this.extensionuuid != null && this.extensionuuid != 0){
					return;
				}
				this.$bvToast.toast('Email synchronization in progress...', {
					title: `Success`,
					variant: 'success',
					solid: true
				});
				setTimeout(() => {	
					this.$store.dispatch('firebase/rebindEmails', this.user.Uid);
				},7000);
			},
			makeLoaderTrue() {
				this.showLoader = true;
			},
			OnScroll() {
				let component = this.$refs.convoList;
				if (component.scrollTop + component.offsetHeight > component.scrollHeight - 1) {
					this.convoListHeight++;
					if (this.sort == 4 || this.sort > 8) {
						this.filteredConvos = this.allFilteredConvos.sort((a, b) => b.DateCreated - a.DateCreated).slice(0, 20 * this.convoListHeight);
					}
				}
			},
			async sortByFolder(i) {
				this.isPriorityClicked = false;
				this.showLoader = true;
				this.convoListHeight =  1;
				this.sort = 8 + i;
				let iFolder = this.sort - 9;
				let convo = [];
				
				if (iFolder >= 0) {
					let val1 = this.user.Folders[iFolder];
					if (val1) {
						let colRef = await db.collection(`Users/${this.user.id}/Prospects`).where('Tags', 'array-contains', val1).get();
						colRef.docs.map((doc) => {
							let data = { id: doc.id, ...doc.data() };	
							let c = this.convos.find(convo => convo.ClientNumber && convo.ClientNumber == data.Number);
							if (c) {
								convo.push(c)
							}
							return data;
						});
					}
				}
				this.allFilteredConvos = convo;
				this.filteredConvos = this.allFilteredConvos.sort((a, b) => b.DateUpdated - a.DateUpdated).slice(0, 20 * this.convoListHeight);
				this.showLoader = false;
			},
			async sortByStage(i) {
				this.isPriorityClicked = false;
				this.showLoader = true;
				this.convoListHeight =  1;
				this.sort = 8 + this.user.Folders.length + i;
				let numFolders = this.user.Folders ? this.user.Folders.length : 0;
				let iStage = this.sort - numFolders - 9;
				let convo = [];
				if (iStage >= 0) {
					let val = this.user.Stages[iStage];
					if (val) {
						let colRef = await db.collection(`Users/${this.user.id}/Prospects`).where('Status', '==', val).get();
						colRef.docs.map((doc) => {
							let data = { id: doc.id, ...doc.data() };
							let c = this.convos.find(convo => convo.ClientNumber && convo.ClientNumber == data.Number);
							if (c) {
								convo.push(c)
							}
							return data;
						});
					}
				}
				this.allFilteredConvos = convo;
				//eslint-disable-next-line
				console.log(this.allFilteredConvos);
				
				this.filteredConvos = this.allFilteredConvos.sort((a, b) => b.DateUpdated - a.DateUpdated).slice(0, 20 * this.convoListHeight);
				this.showLoader = false;
			},
			async sortByPriority(p) {
				this.isPriorityClicked = true;
				this.sort =  5 + this.user.Folders.length + this.user.Stages.length + p;
				this.showLoader = true;
				this.convoListHeight =  1;
				let convo = [];
				let colRef = await db.collection(`Users/${this.user.id}/Prospects`).where('CciMap.Priority', '==', p).get();
				colRef.docs.map((doc) => {
					let data = { id: doc.id, ...doc.data() };
					let c = this.convos.find(convo => convo.ClientNumber == data.Number);
					if (c) {
						convo.push(c)
					}
					return data;
				});
				this.allFilteredConvos = convo;
				this.filteredConvos = this.allFilteredConvos.sort((a, b) => b.DateUpdated - a.DateUpdated).slice(0, 20 * this.convoListHeight);
				this.showLoader = false;
			},
			sortByOldest() {
				// var cnv = [];
				// Object.assign(cnv,convos) ;
				// for (let c of cnv) {
				// 	if (c.hasOwnProperty('EmailDateUpdated')) {
				// 		c.DateUpdated =  c.EmailDateUpdated;
				// 	}
				// }
				// let convos = this.convos.slice(0, 30 * this.convoListHeight);
				// if (this.emails.length) {
				// 	convos = this.filterEmailConvo(convos)
				// }
				this.isPriorityClicked = false;
				this.showLoader = false;
				return this.convos.sort((a, b) => a.DateUpdated - b.DateUpdated).slice(0, 30 * this.convoListHeight).filter(cv => cv.ClientNumber != '');
			},
			sortByRecent() {
				// var cnv = [];
				// Object.assign(cnv,convos) ;
				// for (let c of cnv) {
				// 	if (c.hasOwnProperty('EmailDateUpdated')) {
				// 		c.DateUpdated =  c.EmailDateUpdated;
				// 	}
				// }
				this.isPriorityClicked = false;
				let convos = this.convos.sort((a, b) => b.DateUpdated - a.DateUpdated).slice(0, 30 * this.convoListHeight).filter(cv => cv.ClientNumber != '');
				if (this.emails && this.emails.length) {
					convos = this.filterEmailConvo(convos)
				}
				return convos.sort((a, b) => b.DateUpdated - a.DateUpdated).slice(0, 30 * this.convoListHeight);
			},
			filterEmailConvo(convos) {
				for (let convo of convos) {
					let findp = this.prospects.find(p => p.Number == convo.ClientNumber);						
					if (findp) {
						convo.prospId = findp.id;
						let finde = this.emails.find(e => e.ProspectID == convo.prospId);
						if (finde) {
							convo.isMailExist = true;
							convo.emailConvoID = finde.id;
							if (convo.Unread == 0) {
								convo.Unread = finde.Unread;
							}
							if (convo.DateUpdated < finde.DateUpdated) {
								// convo.EmailDateUpdated = finde.DateUpdated;
								convo.DateUpdated = finde.DateUpdated;
							}
						}
					}
				}
				return convos
			},
			filterClick(sort) {
				this.sort = sort;
				this.convoListHeight=1;
				this.$refs.convoList.scrollTop = 0;
			},
			logDropdownOpen() {
				this.calculateAllFilterCounts();
			// this.$nextTick(() => {
			// 	setTimeout(() => {
			// 		this.calculateAllFilterCounts1();
			// 	}, 0);
			// });
			},
			getCallDetails(value) {
				this.$emit('getCallDetails',value);
			},
			openConvo(convoId, prospId) {
				if(this.autoConvoDetail){
					this.$delete(this.autoConvoDetail.sending, this.autoConvoDetail.id);
					this.autoConvoDetail="";
				}
				this.$store.commit('globals/SET', { var: 'activeProsp', val: prospId });
				this.$store.commit('globals/SET', { var: 'activeConvo', val: convoId });
				this.$store.dispatch('firebase/bindMessages', convoId);
				if(this.emails != null){
				if (this.emails && this.emails.length) {
					let mid = this.getEmailConvoID(prospId);
					if (mid) {
						this.$store.dispatch('firebase/bindMails', mid);
					}else {
						this.$store.dispatch('firebase/clearonlyMailsData');
					}
				// 	this.$store.dispatch('firebase/bindMails', this.getEmailConvoID(prospId));
				}
				}
				if(this.calls != null && this.calls.length){
					let cid = this.getCallsConvoID(prospId);
					if (cid){
						this.$store.dispatch('firebase/bindPhones', cid);
					}else {
						this.$store.dispatch('firebase/clearonlyPhonesData');
				}
				}
				this.changePage('convo');
				if (this.prosp) {
					if (!Object.keys(this.prosp).includes('CarrierType')) {
						getPhoneData({Number:this.prosp.Number})
						.then(res => this.showPhoneData(res))
						.catch(err => this.showPhoneError(err));
					}
				}
				
			},
			getEmailConvoID(prospId) {
				let mailid = '';
				let mail = this.emails.find(e => e.Uid == this.user.Uid && e.ProspectID == prospId);
				if (mail) {
					mailid = mail.id;
				}
				return mailid;
			},
			getCallsConvoID(prospId) {
				let phoneid = '';
				let phone = this.calls.find(e => e.Uid == this.user.Uid && e.ProspectID == prospId);
				if (phone) {
					phoneid = phone.id;
				}
				return phoneid;
			},
			showPhoneData(res) {
				let phoneData = JSON.parse(res.data);
				db.doc(`Users/${this.user.id}/Prospects/${this.prosp.id}`).update({CarrierType:phoneData.carrier.type})
			},
			showPhoneError(err) {
				alert(`Not able to find prospect Number Type : `+ err)
				db.doc(`Users/${this.user.id}/Prospects/${this.prosp.id}`).update({CarrierType:null})
			},
			async deleteProsp() {
				if (confirm("You are about to permanently remove this prospect and all conversation and email data!\n\nAre you sure you want to proceed?")) {
					db.doc(`Users/${this.user.id}/Prospects/${this.activeProsp}`).delete();
					if(this.activeConvo) {
						db.doc(`Conversations/${this.activeConvo}`).delete();
					}
					const cnvref = await db.collection('Emails').where('ProspectID', '==', this.activeProsp).get();
					cnvref.docs.forEach(doc => {
						doc.ref.delete();
					});
                    const cnvrefCall = await db.collection('Calls').where('ProspectID', '==', this.activeProsp).get();
					cnvrefCall.docs.forEach(doc => {
						doc.ref.delete();
					});

					this.changePage('list');
				}
			},
			async openSearch(prosp) {
				this.search = '';
				let convo = this.convos.find(convo => convo.ClientNumber == prosp.Number);
				if (!convo) {
					convo = await db.collection('Conversations').add({
						ClientNumber: prosp.Number,
						AgentNumber: this.user.Twilio,
						Uid: this.user.Uid,
						LastMessage: '',
						DateUpdated: 0,
						Unread: 0
					});
				}
				this.$store.commit('globals/SET', { var: 'activeProsp', val: prosp.id });
				this.$store.commit('globals/SET', { var: 'activeConvo', val: convo.id });
				this.$store.dispatch('firebase/bindMessages', convo.id)
				if (this.emails != null && this.emails.length) {
					let mid = this.getEmailConvoID(prosp.id);	
					if (mid) {
						this.$store.dispatch('firebase/bindMails', mid);
					}else {
						this.$store.dispatch('firebase/clearonlyMailsData');
					}
					// this.$store.dispatch('firebase/bindMails', this.getEmailConvoID(prosp.id));
				}
				if(this.calls != null && this.calls.length){
				let cid = this.getCallsConvoID(prosp.id);
				if (cid) {
						this.$store.dispatch('firebase/bindPhones', cid);
					}else {
						this.$store.dispatch('firebase/clearonlyPhonesData');
					}
				}
				this.changePage('convo');
			},
			changePage(target) {
				if (target == 'list' && this.format != 'big') {
					this.$store.commit('globals/CLEAR', 'activeProsp');
					this.$store.commit('globals/CLEAR', 'activeConvo');
				}
				if (this.page == 'list' || (this.page == 'convo' && this.format == 'big')) {
					this.$store.commit('globals/SET', { var: 'scrollTop', val: this.$refs.convoList.scrollTop });
				}
				this.page = target;
			},
			scroll() {
				this.$refs.convoList.onscroll = () => {
					let component = this.$refs.convoList;
					if (component.scrollTop + component.offsetHeight >= component.scrollHeight - 2) {
						this.convoListHeight++;
					}
				};
			},
			sortByDueTask(convos) {
				this.isPriorityClicked = false;
				let dueConvos = [];
				for (let convo of convos) {
					let findProps = this.prospects.find(props => props.Number && props.Number == convo.ClientNumber);
					if (this.isOverDue(findProps)) {
						dueConvos.push(convo)
					}
				}

				return dueConvos
			},
			sortByDueTask1(convos) {
				return convos.filter(convo => {
					const findProps = this.prospects.find(props => props.Number === convo.ClientNumber);
					return findProps && this.isOverDue(findProps);
				});
			},
			async sortByStarred() {
				this.isPriorityClicked = false;
				this.sort = 4;
				this.showLoader = true;
				this.convoListHeight =  1;
				let convo = [];
				let colRef = await db.collection(`Users/${this.user.id}/Prospects`).where('Starred', '==', true).get();
				colRef.docs.map((doc) => {
					let data = { id: doc.id, ...doc.data() };
					let c = this.convos.find(convo => convo.ClientNumber && convo.ClientNumber == data.Number);
					if (c) {
						convo.push(c)
					}
					return data;
				});
				// let dueConvos = [];
				// for (let convo of convos) {
				// 	let findProps = this.prospects.find(props => props.Number == convo.ClientNumber);
				// 	if (findProps && findProps.hasOwnProperty('Starred') && findProps.Starred) {
				// 		dueConvos.push(convo)
				// 	}
				// }
				// return convo
				// return dueConvos
				this.allFilteredConvos = convo;
				this.filteredConvos = this.allFilteredConvos.sort((a, b) => b.DateUpdated - a.DateUpdated).slice(0, 20 * this.convoListHeight);
				this.showLoader = false;
			},
			sortByScheduled (convos) {
				this.isPriorityClicked = false;
				let scheduledConvos = [];
				for (let convo of convos) {
					if (convo.hasOwnProperty('ScheduledCount') && convo.ScheduledCount && convo.ClientNumber) {
						scheduledConvos.push(convo);
						this.scheduledConvo.push(convo);
					}
				}
				return scheduledConvos
			},
			sortByAutopilot (convos) {
				this.isPriorityClicked = false;
				let autopilotConvos = [];
				for (let convo of convos) {
					if (convo.hasOwnProperty('autoSms') && convo.autoSms && convo.ClientNumber) {
						autopilotConvos.push(convo)
					}
				}
				return autopilotConvos
			},
			sortByFeedbackNeeded (convos) {
				this.isPriorityClicked = false;
				let feedbackneededConvos = [];
				for (let convo of convos) {
					if (convo.hasOwnProperty('needHumanFeedback') && convo.needHumanFeedback && convo.ClientNumber) {
						feedbackneededConvos.push(convo)
					}
				}
				return feedbackneededConvos
			},
			soryByErrored(convos) {
				let erroredConvos = [];
				
				for (let convo of convos) {
					if (convo.Errors && convo.Errors > 0) {
						erroredConvos.push(convo)
					}
				}
				//eslint-disable-next-line
				console.log("erroredConvos:", erroredConvos);
				return erroredConvos
			},
			sortByUnread(convos) {
				this.isPriorityClicked = false;
				return convos.filter(convo => convo.Unread).slice(0, 30 * this.convoListHeight);
			},
			isOverDue(findProps) {
				let val = false;
				if(findProps && findProps.Tasks) {
					for (let task of findProps.Tasks) {
						if (task.DueOn && task.Status == 'draft' && (task.DueOn <= Date.now() || this.isToday(new Date(task.DueOn)))) {
							val = true;
							break	
						}
					}
					
				}
				return val
			},
			isToday(date) {
				const today = new Date()
				return date.getDate() === today.getDate() &&
					date.getMonth() === today.getMonth() &&
					date.getFullYear() === today.getFullYear();
			},
			manageLoader() {
				this.showLoader = !this.showLoader;
			},
			async calculateAllFilterCounts() {
				await this.$nextTick(async() => {
				this.scope1 = true;
				this.scope1Loader = false;
				this.scope2 = true;
				this.scope2Loader = false;
				this.scope3 = true;
				this.scope3Loader = false;
				this.scope4 = true;
				this.scope4Loader = false;
				this.scope5 = true;
				this.scope5Loader = false;
				this.scope6 = true;
				this.scope6Loader = false;
				
				this.unreadCount = this.sortByUnread(this.convos).length;
				this.$store.commit('globals/SET', { var: 'unreadCountTotal', val: this.unreadCount });
				if(this.unreadCount != null){
					this.scope1 = true;
					this.scope1Loader = false;
				}

				this.dueTaskCount = await this.sortByDueTask1(this.convos).length;
				this.$store.commit('globals/SET', { var: 'dueTaskCountTotal', val: this.dueTaskCount });
				if(this.dueTaskCount != null){
					this.scope2 = true;
					this.scope2Loader = false;
				}
							
				let convo = [];
				let colRef = await db.collection(`Users/${this.user.id}/Prospects`).where('Starred', '==', true).get();
				colRef.docs.map((doc) => {
					let data = { id: doc.id, ...doc.data() };
					let c = this.convos.find(convo => convo.ClientNumber && convo.ClientNumber == data.Number);
					if (c) {
						convo.push(c)
					}
					return data;
				});
				this.startedCount = convo.length;
				this.$store.commit('globals/SET', { var: 'startCount', val: this.startedCount });
				if(this.startedCount != null){
					this.scope3 = true;
					this.scope3Loader = false;
				}

				this.scheduledCount = this.sortByScheduled(this.convos).length;
				this.$store.commit('globals/SET', { var: 'scheduleCountTotal', val: this.scheduledCount });
				if(this.scheduledCount != null){
					this.scope4 = true;
					this.scope4Loader = false;
				}
			});
            },
			async calculateAllFilterCounts2() {
			try {
				const scheduledIds = this.scheduledConvo.map(convo => convo.id);
				const messagesPromises = scheduledIds.map(async (convoId) => {
					const messagesSnapshot = await db
						.collection(`Conversations/${convoId}/Messages`)
						.orderBy('Date', 'desc')
						.get();
					const messages = messagesSnapshot.docs.map(doc => ({
						id: doc.id,
						convoId,
						...doc.data()
					}));
					return messages;
				});
				const allMessages = await Promise.all(messagesPromises);
				const flatMessages = allMessages.flat();
				const scheduledMessages = flatMessages.filter(m => m.SmsStatus === 'scheduled');
				const uniqueConversations = new Set(scheduledMessages.map(m => m.convoId));
				const scheduledSendOnArray = scheduledMessages.map(m => m.SendOn);
				//eslint-disable-next-line
				console.log('scheduledSendOnArray:', scheduledSendOnArray);
				const uniqueScheduledConvoCount = uniqueConversations.size;
				this.$store.commit('globals/SET', { var: 'scheduleCountTotal', val: uniqueScheduledConvoCount });
				// this.dueTaskCount = await this.sortByDueTask1(this.convos).length;
				// this.$store.commit('globals/SET', { var: 'dueTaskCountTotal', val: this.dueTaskCount });
			} catch (error) {
				//eslint-disable-next-line
				console.error('Error calculating scheduled counts:', error);
			}
		}
		},
		watch: {
			showList: {
				immediate: true,
				handler(showList) {
					if (showList) {
						this.$nextTick(() => {
							this.$refs.convoList.scrollTop = this.scrollTop;
						})
					}
				}
			},
		},
		data() {
			return {
				needHumanFeedback:false,
				isNewProsp:false,
				optIn: false,
				NoteValue:'',
				form: {
					Status:"New"
				},
				autoConvoDetail: '',
				convoListHeight: 1,
				page: 'list',
				search: '',
				sort: 0,
				showLoader:false,
				filteredConvos:[],
				allFilteredConvos:[],
				isPriorityClicked:false,
				unreadCount: null,
                dueTaskCount: null,
                scheduledCount: null,
				startedCount:null,
				autoPilotCount:null,
				feedbackCount:null,
				oldConvos:[],
				scope1Loader:true,
				scope1:false,
				scope2Loader:true,
				scope2:false,
				scope3Loader:true,
				scope3:false,
				scope4Loader:true,
				scope4:false,
				scope5Loader:true,
				scope5:false,
				scope6Loader:true,
				scope6:false,
				scheduledConvo:[],
			}
		},
		mounted() {
			this.scroll();
			// this.calculateAllFilterCounts();
		},
	}
</script>

<style scoped>
	.red-background {
		background-color: yellow !important;
	}
	#ProspectModal1___BV_modal_outer_{
		z-index: 99999 !important;
	}
	#ConvoList {
		position: absolute;
		width: 100%;
		height: 100%;
		z-index: 1001;
	}
	#Prospect {
		position: absolute;
		width: 100%;
		height: 100%;
		left: 0;
		/* z-index: 1001; */
	}
	.active {
		background-color: #E5E5E5;
	}
    .collapse-width-enter,
    .collapse-width-leave-to{
        max-width: 0;
    }
    .collapse-width-leave,
    .collapse-width-enter-to{
        max-width: 35em;
    }
    .collapse-width-enter-active,
    .collapse-width-leave-active{
        transition: all .5s ease;
    }
	.loader1 {
position: fixed;
z-index: 1010;
top: 50%;
margin: auto;
left: 50%;
z-index: 1111;
}

.loader1:before {
content: "";
display: block;
position: fixed;
top: 0;
left: 0;
width: 100%;
min-height: 100%;
background-color: rgba(0, 0, 0, 0.3);
z-index: 1111;
}

.lds-ripple {
display: inline-block;
top: 50%;
position: relative;
width: 64px;
height: 64px;
}

.lds-ripple div {
position: absolute;
top: 50%;
border: 4px solid #000000;
opacity: 1;
border-radius: 50%;
animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}

.lds-ripple div:nth-child(2) {
animation-delay: -0.5s;
}

@keyframes lds-ripple {
0% {
top: 28px;
left: 28px;
width: 0;
height: 0;
opacity: 1;
}
100% {
top: -1px;
left: -1px;
width: 58px;
height: 58px;
opacity: 0;
}
}
</style>
<style>
.forIpadUIConvo .dropdown-menu.dropdown-menu-right.show{
	transform: translate3d(-115px, 10px, 0px)!important;
}
/*.LoadMoreConvoScroll{
	margin-bottom: 2px;
}*/
</style>
